import { render, staticRenderFns } from "./DomainBulkTagsEdit.vue?vue&type=template&id=5215cfe0"
import script from "./DomainBulkTagsEdit.vue?vue&type=script&lang=js"
export * from "./DomainBulkTagsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports